import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {CookieService} from "ng2-cookies";

@Injectable({
  providedIn: 'platform'
})
export class Localiser {

  language: string;
  public languageName: string;

  dictionary: any;

  constructor(public http: HttpClient, private cookieService: CookieService) {

    if (cookieService.check("language")) {
      if (cookieService.get("language") == "en") {
        this.language = "en";
      } else if (cookieService.get("language") == "es") {
        this.language = "es";
      } else {
        this.language = "en";
      }
    } else {
      this.language = "en";
    }

    this.dictionary = null;
    this.load();
  }

  public load (language = this.language) {
    this.http.get('assets/languages/language-' + language + '.json').subscribe( data => {
      this.dictionary = data;
      this.language = language;
      this.languageName = this.get("languageName");
      this.cookieService.set("language", language);
    })
  }

  public get(key) {
    try {
      let text = this.dictionary[this.language][key];
      if (text == "" || text == null) {
        return key;
      } else {
       return text;
      }
    } catch (e) {
      return key;
    }
  }

  public format(template: string, variables: Record<string, string>): string {
    return template.replace(/{(.*?)}/g, (_, key) => variables[key] ?? `{${key}}`);
  }
}
